// src/pages/admin/AdminUsers.js
import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState({ status: '', role: '', q: '' });
  const [selected, setSelected] = useState(null);
  const [balanceForm, setBalanceForm] = useState({ amount: '', carbon_amount: '' });

  const load = () => api.get('/admin/users', { params: filter }).then(r => setUsers(r.data.users || [])).catch(() => {});
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => {
    await api.put(`/admin/users/${id}/status`, { status });
    toast.success(`User ${status}`);
    load();
  };

  const addBalance = async (id) => {
    await api.put(`/admin/users/${id}/balance`, balanceForm);
    toast.success('Balance updated');
    setSelected(null);
    setBalanceForm({ amount: '', carbon_amount: '' });
    load();
  };

  const statusColor = { active: 'green', pending: 'yellow', suspended: 'pink' };
  const kycColor = { verified: 'green', pending: 'yellow', under_review: 'cyan', rejected: 'pink' };

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">USER <span style={{ color: 'var(--neon-green)' }}>MANAGEMENT</span></h1>

      <div style={{ display: 'flex', gap: '1rem', margin: '1.5rem 0', flexWrap: 'wrap' }}>
        <input className="form-input" style={{ width: '220px' }} placeholder="Search name / email / GCI..." value={filter.q} onChange={e => setFilter(p => ({ ...p, q: e.target.value }))} />
        <select className="form-select" style={{ width: '140px' }} value={filter.role} onChange={e => setFilter(p => ({ ...p, role: e.target.value }))}>
          <option value="">All Roles</option>
          <option value="individual">Individual</option>
          <option value="organization">Organization</option>
          <option value="compliance_entity">Compliance</option>
        </select>
        <select className="form-select" style={{ width: '140px' }} value={filter.status} onChange={e => setFilter(p => ({ ...p, status: e.target.value }))}>
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="pending">Pending</option>
          <option value="suspended">Suspended</option>
        </select>
        <div style={{ marginLeft: 'auto', fontFamily: 'Space Mono, monospace', fontSize: '0.65rem', color: 'var(--muted)', display: 'flex', alignItems: 'center' }}>{users.length} users</div>
      </div>

      {selected && (
        <div style={{ background: 'var(--surface)', border: '1px solid var(--neon-green)', padding: '1.5rem', marginBottom: '1.5rem' }}>
          <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '1.2rem', letterSpacing: '2px', marginBottom: '1rem' }}>ADD BALANCE — {selected.name}</div>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">INR Amount (₹)</label>
              <input className="form-input" type="number" value={balanceForm.amount} onChange={e => setBalanceForm(p => ({ ...p, amount: e.target.value }))} placeholder="500000" />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Carbon Credits (tCO₂e)</label>
              <input className="form-input" type="number" value={balanceForm.carbon_amount} onChange={e => setBalanceForm(p => ({ ...p, carbon_amount: e.target.value }))} placeholder="1000" />
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
              <button className="btn btn-primary" onClick={() => addBalance(selected.id)}>ADD BALANCE</button>
              <button className="btn btn-secondary" onClick={() => setSelected(null)}>CANCEL</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <table className="data-table">
          <thead>
            <tr><th>User</th><th>Role</th><th>GCI ID</th><th>KYC</th><th>Status</th><th>INR Balance</th><th>Carbon</th><th>Joined</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td>
                  <div style={{ fontWeight: 600 }}>{u.name}</div>
                  <div style={{ color: 'var(--muted)', fontSize: '0.65rem' }}>{u.email}</div>
                  <div style={{ color: 'var(--muted)', fontSize: '0.6rem' }}>{u.sector}</div>
                </td>
                <td><span className="badge badge-muted">{u.role}</span></td>
                <td style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.65rem', color: u.gci_id ? 'var(--neon-green)' : 'var(--muted)' }}>{u.gci_id || 'Pending'}</td>
                <td><span className={`badge badge-${kycColor[u.kyc_status] || 'muted'}`}>{u.kyc_status?.replace('_', ' ')}</span></td>
                <td><span className={`badge badge-${statusColor[u.status] || 'muted'}`}>{u.status}</span></td>
                <td style={{ color: 'var(--neon-green)', fontFamily: 'Space Mono, monospace', fontSize: '0.72rem' }}>₹{(u.balance || 0).toLocaleString()}</td>
                <td style={{ color: 'var(--neon-cyan)', fontFamily: 'Space Mono, monospace', fontSize: '0.72rem' }}>{u.carbon_balance || 0}</td>
                <td style={{ color: 'var(--muted)', fontSize: '0.65rem' }}>{new Date(u.created_at).toLocaleDateString('en-IN')}</td>
                <td>
                  <div style={{ display: 'flex', gap: '0.3rem', flexWrap: 'wrap' }}>
                    <button className="btn btn-sm btn-secondary" onClick={() => setSelected(u)}>Balance</button>
                    {u.status === 'active'
                      ? <button className="btn btn-sm btn-danger" onClick={() => setStatus(u.id, 'suspended')}>Suspend</button>
                      : <button className="btn btn-sm btn-primary" onClick={() => setStatus(u.id, 'active')}>Activate</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
